import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function getForecasterUserAssetsTweets() {
  const url = `${backendUrl}/api/forecasters/tweets/user-assets/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении активов пользователя');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterUserAssets error:', error);
    throw error;
  }
}

export async function getForecasterUserAssetsTelegram() {
  const url = `${backendUrl}/api/forecasters/telegram/user-assets/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении активов пользователя');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterUserAssets error:', error);
    throw error;
  }
}